import React from 'react';

import { Icon } from '@/shared/icons';

interface DetailsLayerProps {
  /** Título da sub-página, ao lado do "Voltar". */
  title: string;
  /** Sufixo do `data-testid`: vira `details-layer-<testId>`. */
  testId: string;
  onBack: () => void;
  /** Ação opcional à direita da barra (ex.: editar contato). */
  action?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Moldura de sub-página do painel de detalhes.
 *
 * Ela desliza POR CIMA do índice, que continua montado embaixo — é isso que
 * preserva a rolagem do índice ao voltar, em vez de devolver a pessoa ao topo
 * da lista toda vez.
 *
 * Por isso a moldura é `absolute` e pinta o próprio fundo (`.cdp-pane--sub`):
 * sem fundo próprio, o índice apareceria através dela.
 */
const DetailsLayer: React.FC<DetailsLayerProps> = ({ title, testId, onBack, action, children }) => (
  <section className="cdp-pane cdp-pane--sub" data-testid={`details-layer-${testId}`}>
    <div className="cdp-subhead">
      <button type="button" className="cdp-back" onClick={onBack} data-testid="details-back">
        <Icon name="chevron-left" className="w-4 h-4" />
        Voltar
      </button>
      <span className="cdp-subsep" aria-hidden="true" />
      <h3 className="cdp-subt">{title}</h3>
      {action}
    </div>
    <div className="cdp-subbody">{children}</div>
  </section>
);

export default DetailsLayer;
